<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="col-lg-12">
    <b-row>
        <b-col style="text-align:center">
          <h3>Recursos / Formulas</h3>
        </b-col>
    </b-row>
    <div class="card">
      <div class="tab-content">
        <div class="table-responsive">
          <div class="d-flex justify-content-between align-items-center mb-4 pl-4">
            <b-pagination class="p-0 m-0"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table">
            </b-pagination>
            <div class="d-flex align-items-center pl-3 mr-auto">
              <label class="p-0 m-0 pr-3 text-purple">Filtrar por tags</label>
              <vue-tags-input
                v-model="taglist"
                :autocomplete-items="tagslist"
                :add-only-from-autocomplete="true"
                @tags-changed="updatelist"
              />
            </div>
              <div class="col-md-3">
              <ResourceSearchs :routeApi="'formula'" ref="searchcomponent"
                :perPage = "perPage"
                :newTags2 = "newTags2"
                @update="onUpdateDataResource"
                @loading="onLoading"
              />
            </div>
            <b-button @click="onNew" variant="success">
              + Añadir
            </b-button>
          </div>
          <b-table hover :items="resources"
          :fields="fields"
          :per-page="0"
          :current-page="currentPage"
          >
           <template v-slot:cell(actions)="row">
            <b-button class="btn btn-icon btn-icon-mini btn-round btn-info" @click="info(row.item, row.index, $event.target)">
              <i class="zmdi zmdi-edit"></i>
            </b-button>
             <b-button class="btn btn-icon btn-icon-mini btn-round btn-danger" @click="ondelete(row.item)">
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
  <!-- Info modal -->
    <b-modal :id="infoModal.id" :title="infoModal.title" hide-footer>
       <div class="modal-body">
              <div class="d-block">
                <div>
                  <label for="">Nombre</label>
                  <b-form-input
                    id="NOMBRE"
                    v-model="selectedItem.NOMBRE"
                    placeholder="Nombre..."
                    :state="($v.selectedItem.NOMBRE.$dirty && submitted)?
                    !$v.selectedItem.NOMBRE.$error : null"
                    aria-describedby="nombre-feedback" />
                   <b-form-invalid-feedback id="nombre-feedback">
                    Este campo es requerido.
                  </b-form-invalid-feedback>
                </div>
                <br />
                <div>
                  <label for="">Fórmula</label>
                  <b-form-textarea
                    id="textarea"
                    v-model="selectedItem.FORMULA"
                    placeholder="Fórmula..."
                    rows="3"
                    max-rows="6"
                    :state="($v.selectedItem.FORMULA.$dirty && submitted)?
                    !$v.selectedItem.FORMULA.$error : null"
                    aria-describedby="formula-feedback"
                  >
                  </b-form-textarea>
                  <b-form-invalid-feedback id="formula-feedback">
                    Este campo es requerido.
                  </b-form-invalid-feedback>
                </div>
                <br />
                <div>
                  <label for="">Número de Parámetros</label>
                  <b-form-input
                    id="NUM_PARAMETROS"
                    type="number"
                    min="0"
                    v-model="selectedItem.NUM_PARAMETROS"
                    placeholder="Número..."
                    :state="($v.selectedItem.NUM_PARAMETROS.$dirty && submitted)?
                    !$v.selectedItem.NUM_PARAMETROS.$error : null"
                    aria-describedby="num-feedback" />
                   <b-form-invalid-feedback id="num-feedback">
                    Este campo es requerido.
                  </b-form-invalid-feedback>
                </div>
                <br />
                <div>
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0 mb-2">
                    <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.PLANTILLAS_ID !== null && selectedItem.PLANTILLAS_ID !== 0"
                        @click="openResourceWithParam('templates', selectedItem.PLANTILLAS_ID)"/>
                    Plantilla
                    <searchtemplates class="pl-2" idModal="mdlSearchPlantilla"
                      v-on:selected="onSelectedPlantilla($event)">
                    </searchtemplates>
                  </div>
                  <b-form-textarea
                    id="textarea"
                    disabled class="form-control"
                    v-bind:value="getTranslationTemplate(selectedItem.PLANTILLAS_TEXTO)"
                    placeholder="Texto de la plantilla..."
                    rows="7"
                    max-rows="7"
                    :readonly=true >
                  </b-form-textarea>
                </div>
                <label for="Tag">
                  <br>
                    Etiquetas</label>
                      <div>
                      <vue-tags-input
                        v-model="tag"
                        :tags="tags"
                        :autocomplete-items="autocompleteItems"
                        @tags-changed="update"
                      />
                    </div>
              </div>
              <div class="modal-footer">
                <button type="button" @click="save"
                class="btn btn-info btn-round waves-effect">
                  Guardar</button>
                <b-button class="btn btn-default btn-round waves-effect" block
                @click="$bvModal.hide('info-modal')">Cerrar</b-button>
            </div>
        </div>
    </b-modal>
</div>

</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';
import { required } from 'vuelidate/lib/validators';
import searchtemplates from '../templates/SearchTemplates.vue';
import ResourceSearchs from '../../../components/panel/ResourceSearchs.vue';
import searchMixin from '../../../mixins/search';
import translationMixin from '../../../mixins/translation';

/* function truncate(text, length, suffix) {
  if (text.length > length) {
    return text.substring(0, length) + suffix;
  }
  return text;
} */
export default {
  components: {
    VueTagsInput,
    searchtemplates,
    ResourceSearchs,
  },
  name: 'gridFormulas',
  mixins: [searchMixin, translationMixin],
  data() {
    return {
      perPage: 20,
      rows: 0,
      submitted: false,
      currentPage: 1,
      fields: [
        { key: 'ID', label: 'ID' },
        { key: 'NOMBRE', label: 'Nombre' },
        { key: 'FORMULA', label: 'Fórmula' },
        { key: 'actions', label: 'Acciones', tdClass: 'tdActionClass' },
      ],
      resources: [],
      selectedItem: {
        ID: null,
        NOMBRE: null, // Nombre para buscar en el repositorio
        FORMULA: null, // Operación de la formula
        NUM_PARAMETROS: null, // Numero de parámetros
        PLANTILLAS_ID: null, // Enlace a las plantillas
        PLANTILLAS_TEXTO: [],
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      tag: '',
      taglist: '',
      tags: [],
      newTags: [],
      newTags2: [],
      tagslist: [],
      autocompleteItems: [],
    };
  },
  validations: {
    selectedItem: {
      NOMBRE: {
        required,
      },
      FORMULA: {
        required,
      },
      NUM_PARAMETROS: {
        required,
      },
      PLANTILLAS_ID: {
        required,
      },
    },
  },
  methods: {
    onNew() {
      this.submitted = false;
      this.limpiar();
      this.infoModal.title = 'Nueva Plantilla';
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    limpiar() {
      this.selectedItem.ID = null;
      this.selectedItem.NOMBRE = null;
      this.selectedItem.FORMULA = null;
      this.selectedItem.NUM_PARAMETROS = null;
      this.selectedItem.PLANTILLAS_ID = null;
      this.selectedItem.PLANTILLAS_TEXTO = [];
      this.tag = '';
      this.tags = [];
    },
    async ondelete(item) {
      const confirmation = await this.$bvModal.msgBoxConfirm('Esta a punto de eliminar un registro ¿Esta seguro?');
      if (confirmation) {
        /** Elimino los tags asociados */
        const url = `Tagsformulas/deleteTags/${item.ID}`;
        this.axios.get(url);

        this.loading = true;
        const response = await this.axios.post('formula/delete', { ID: item.ID });
        if (response.data.status === 'success') {
          this.loading = false;
          this.$toasted.show('Se elimino el registro seleccionado.', { theme: 'outline', type: 'success', duration: 5000 });
          this.getPostData();
        } else {
          this.loading = false;
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
      }
    },
    async info(item, index, button) {
      this.submitted = false;
      this.infoModal.title = 'Editar Fórmula';
      /* this.infoModal.content = JSON.stringify(item, null, 2);
      this.selectedItem.ID = item.ID;
      this.selectedItem.NOMBRE = item.NOMBRE;
      this.selectedItem.FORMULA = item.FORMULA;
      this.selectedItem.NUM_PARAMETROS = item.NUM_PARAMETROS;
      this.selectedItem.PLANTILLAS_ID = item.PLANTILLAS_ID; */
      this.loading = true;
      try {
        const response = await this.axios.get('formula/getformula', {
          params: {
            id: item.ID,
          },
        });
        this.selectedItem = response.data.content;
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer una formula', { type: 'warning' });
      }
      this.loading = false;
      this.getExistingTags(item.ID);
      this.$root.$emit('bv::show::modal', this.infoModal.id, button);
    },
    onSelectedPlantilla(item) {
      this.selectedItem.PLANTILLAS_ID = item.ID;
      this.selectedItem.PLANTILLAS_TEXTO = item.PLANTILLA;
      this.$root.$emit('bv::hide::modal', 'mdlSearchPlantilla');
    },
    async save() {
      this.submitted = true;
      this.$v.selectedItem.$touch();
      if (this.$v.selectedItem.$anyError) {
        return;
      }
      this.loading = true;
      const templateData = {
        ID: this.selectedItem.ID || -1,
        NOMBRE: this.selectedItem.NOMBRE,
        FORMULA: this.selectedItem.FORMULA,
        NUM_PARAMETROS: this.selectedItem.NUM_PARAMETROS,
        PLANTILLAS_ID: this.selectedItem.PLANTILLAS_ID,
      };
      try {
        const response = await this.axios.post('formula/store', templateData);
        if (response.data.status === 'success') {
          // Solo si esta creando agrego el evento
          if (this.selectedItem.ID === -1 || this.selectedItem.ID === null) {
            const bc = new BroadcastChannel('new_resource_formula');
            bc.postMessage({
              ID: response.data.id,
              NOMBRE: this.selectedItem.NOMBRE,
              FORMULA: this.selectedItem.FORMULA,
              NUM_PARAMETROS: this.selectedItem.NUM_PARAMETROS,
              PLANTILLAS_ID: this.selectedItem.PLANTILLAS_ID,
            });
          }

          const url = `Tagsformulas/deleteTags/${response.data.id}`;
          const url2 = 'Tagsformulas/saveTag';

          await this.axios.get(url);
          this.newTags.forEach(async (a) => {
            const resp = await this.axios.get(`Tags/findTagByName/${a.text}`, { name: a.text });
            if (resp.data.status === 'success') {
              await this.axios.post(url2, { id: resp.data.id, idtexto: response.data.id });
            } else {
              await this.axios.post(url2, { id: a.key, idtexto: response.data.id });
            }
          });

          this.$toasted.show('Los datos se guardaron satisfactoriamente.', { theme: 'outline', type: 'success', duration: 5000 });
          this.$root.$emit('bv::hide::modal', this.infoModal.id);
          this.limpiar();

          // Auto close if coming from a create event
          if (this.bAutoClose) {
            window.open('', '_self').close();
          }

          await this.getPostData();
        } else {
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
        this.loading = false;
      } catch (e) {
        const resp = e;
        if (!resp.body.Ok) {
          this.$toasted.show(resp.body.Message, { theme: 'outline', type: 'error', duration: 5000 });
        }
        this.loading = false;
      }
    },
    async getFormulas() {
      this.loading = true;

      try {
        const response = await this.axios.get('formula');
        this.resources = response.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    async getPostData() {
      this.loading = true;
      try {
        const response = await this.axios.get('formula', {
          params: {
            currentPage: this.currentPage,
            size: this.perPage,
            newTags: this.newTags2,
            resourcetosearch: this.$refs.searchcomponent.resoursetosearch,

          },
        });
        this.rows = response.data.rows;
        this.resources = Object.keys(response.data.results).map(k => response.data.results[k]);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    initItems() {
      const url = 'Tags';
      const datos = [];

      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ text: a.NOMBRE, key: a.ID });
        });
        this.autocompleteItems = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    listTags() {
      const url = 'Tags';
      const datos = [];
      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ key: a.ID, text: a.NOMBRE });
        });
        this.tagslist = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    updatelist(newTags) {
      this.newTags2 = newTags;
      this.getPostData();
    },
    update(newTags) {
      this.tags = newTags;
      this.newTags = newTags;
    },
    async getExistingTags(idtxt) {
      const url = `Tagsformulas/findByFormula/${idtxt}`;
      const datos = [];
      this.loading = true;

      try {
        this.axios.get(url).then((res) => {
          res.data.forEach((a) => {
            datos.push({ text: a.NOMBRE, key: a.ID });
          });
          this.tags = datos;
        })
          .catch((error) => {
            console.error(error);
          });
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.getPostData();
    this.initItems();
    this.listTags();

    // Open create modal automatically
    const self = this;
    const bc = new BroadcastChannel('new_resource_formula_open');
    bc.onmessage = () => {
      self.bAutoClose = true;
      self.onNew();
    };

    if (this.$route.params.id != null) {
      const item = {
        ID: this.$route.params.id,
      };
      this.info(item, null, null);
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getPostData().catch((error) => {
          console.error(error);
        });
      },
    },
  },
  filters: {
    truncate(text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      }
      return text;
    },
  },
};
</script>
<style>
  .tdActionClass{
    width: 180px;
    text-align: center
  }
</style>
